<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <div style="margin-bottom: 25px">
      <a-input v-model="richTitle" addon-before="标题" placeholder="请输入标题" />
    </div>
    <!-- <JEditor v-model="richText" /> -->
    <WangEditor v-model="richText" />
  </j-modal>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { postAction, putAction, uploadAction } from '@/api/manage'
// import JEditor from '@/components/jeecg/JEditor'
import WangEditor from '@/components/WangEditor'

export default {
  name: 'RichTextModal',
  components: { Editor, Toolbar, WangEditor },
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      isEdit: false,
      editor: null,
      richTitle: '',
      richText: '',
      richInfo: {},
    }
  },
  methods: {
    add() {
      this.visible = true
      this.richTitle = ''
      this.richText = ''
    },
    edit(record) {
      this.visible = true
      this.isEdit = true
      this.richText = record.content
      this.richTitle = record.title
      this.richInfo = record
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      if (this.isEdit) {
        putAction('/dataReport/edit', {
          title: this.richTitle,
          content: this.richText,
          id: this.richInfo.id,
          tenantId: this.richInfo.tenantId,
        }).then((res) => {
          if (res.success) {
            this.$message.success(res.result || '编辑成功')
            this.$emit('updateTable')
          }
        })
      } else {
        postAction('/dataReport/add', {
          title: this.richTitle,
          content: this.richText,
        }).then((res) => {
          if (res.success) {
            this.$message.success(res.result || '添加成功')
            this.$emit('updateTable')
          }
        })
      }
      this.close()
    },
    submitCallback() {
      this.$emit('ok')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
